import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { ComponentLoader } from 'components/index';
import { useIgnoreErrorsWhen } from 'components/molecules/ComponentLoader/hooks';
import fetch from 'features/common/fetch';
import { getInsuredPersons } from 'features/views/taskDetail/selectors';
import { generateAddressFromValue, getStringOrOneOf } from 'features/views/taskDetail/utils';
import { equalOrThreeDashes } from 'utils';

const { urls } = fetch.constants;

export const Informations = ({ onReload }) => {
	const insuredPersons = useSelector(getInsuredPersons);
	const insuredPerson = insuredPersons?.first;

	const ignoreErrorsForTaskDetailUserHasNoAccess = useIgnoreErrorsWhen({
		fetchStorePath: urls.taskDetail,
		attributePath: ['metaData', 'parsedContent', 'status'],
		value: 403,
	});

	return (
		<ComponentLoader
			onReload={onReload}
			fetchStorePath={urls.taskDetail}
			ignoreErrors={ignoreErrorsForTaskDetailUserHasNoAccess}
		>
			<Paper sx={{ p: 3, borderRadius: 2 }}>
				<Stack spacing={2}>
					<SectionHeader text={getLabelMessage('detail:informationsSubheader')} />
					<TableContainer>
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell>{getLabelMessage('detail:informationsName')}</TableCell>
									<TableCell>{getLabelMessage('detail:informationsInsuranceNumber')}</TableCell>
									<TableCell>{getLabelMessage('detail:informationsAddress')}</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{insuredPerson ? (
									<TableRow>
										<TableCell>
											{equalOrThreeDashes(
												getStringOrOneOf(
													insuredPerson.firstname,
													insuredPerson.surname,
													insuredPerson.name,
												),
											)}
										</TableCell>
										<TableCell>{equalOrThreeDashes(insuredPerson.birthNo)}</TableCell>
										<TableCell>
											{equalOrThreeDashes(
												generateAddressFromValue(
													insuredPerson.street,
													insuredPerson.zipCode,
													insuredPerson.city,
												),
											)}
										</TableCell>
									</TableRow>
								) : null}
							</TableBody>
						</Table>
					</TableContainer>
				</Stack>
			</Paper>
		</ComponentLoader>
	);
};

Informations.propTypes = {
	onReload: PropTypes.func,
};

export default Informations;
